// Similar to sections/product-page.js
const initWishlist = () => {
  $(document).on('click touchend', '#quicklook-modal [data-wishlist-clickable]', (e) => {
    const $item = $(e.currentTarget);
    $item.parent().find('.swym-button').trigger('click');
  });

  // [ADA]
  $(document).on('keypress', '#quicklook-modal [data-wishlist-clickable]', (e) => {
    const key = e.which;

    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });
};

const initWishlistQuickviewOpen = () => {
  function swymCallbackFn (swat) {
    // console.log('[Quickview] swat', window._swat, swat);
    function swymAttachEvents() {
      swat.initializeActionButtons('#quicklook-modal');
    }

    document.addEventListener('quickview:loaded', () => {
      swymAttachEvents();
    });

    document.addEventListener('quickview:variant-change', (event) => {
      const variant_id = _.last(event.data.detail.variant.id.split('/'));
      const btn =  document.querySelector('#swym-quick-view');

      if (btn) {
        btn.setAttribute('data-variant-id', variant_id);
      }
      swymAttachEvents();
    });
  }

  if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);
};

const initWishlistQuickviewMobileOpen = () => {
  function swymCallbackFn (swat) {
    // console.log('[Quickview] swat', window._swat, swat);
    function swymAttachEvents() {
      swat.initializeActionButtons('#quicklook-modal-mobile');
    }

    document.addEventListener('quickview-mobile:loaded', () => {
      swymAttachEvents();

      // It can take a moment to load the image
      window.setTimeout(() => {
        // Place the wishlist button at the correct location on mobile due to dynamic image size
        const wishlist_icon_width = 30;
        const wishlist_distance_from_edge = 30;
        const image_width = $('[data-quickview-mobile] [data-product-main] img').width();
        $('[data-quickview-mobile] .swym-button-bar').css({'opacity': 1, 'left': `calc(50% + ${image_width / 2}px - ${wishlist_distance_from_edge}px - ${wishlist_icon_width / 2}px)`});
      }, 500);
    });

    document.addEventListener('quickview-mobile:variant-change', (event) => {
      const variant_id = _.last(event.data.detail.variant.id.split('/'));
      const btn =  document.querySelector('#swym-quick-view');

      if (btn) {
        btn.setAttribute('data-variant-id', variant_id);
      }
      swymAttachEvents();
    });
  }

  if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);
};

export {
  initWishlist,
  initWishlistQuickviewOpen,
  initWishlistQuickviewMobileOpen,
};
